// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const Eaztrium = {
  productCode: "SBOVZ-PMS",
  productName: "Eaztrium",
  ingredients: "Asparagus densiflorus, Cimicifuga racemosa, Saraca asoca, Vitex negundo",
  overview:"Botanical and whole food Vitamin Supplement for Premenstrual Relief",
  assay:"Vitamin B1: 0.6 mg; Vitamin B6: 0.95 mg; Vitamin B9: 110 mcg; Vitamin C: 30 mg; Vitamin K2: 20 mcg; Vitamin D3: 300 IU; Vitamin E: 5 mg; Iron: 12 mg; Asparagus densiflorus extract:150 mg; Cimicifuga racemosa extract:50 mg; Saraca asoca extract: 75 mg; Vitex negundo extract: 75 mg",
  coNutrients:"Include phytoestrogens, triterpene glycosides, Phenylpropanoids helps regulate estrogen levels by improving metabolic function, and hormone metabolism.",
  studies:"",
  benefits:" The symptoms of premenstrual syndrome(PMS), like mood swings, irritability, depression, anxiety, fluid retention, bloating, breast tenderness, sugar cravings, headache, sleep disturbances, joint pain, heavy bleeding, hot flashes, dry skin, acne, hair loss, memory problems, poor sleep and no sex drive affect 75% of women. Some of the reasons being hormonal imbalance, increase of estrogen levels and decrease of progesterone levels, either relatively or absolutely",
  functionalUse: {
    main: "💊︎ Capsule",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForConditions/Eaztrium.png"
    

  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",

  ]
};

export default Eaztrium;
